import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import constants from "./utils/constants";
import strings from "./utils/property-file/firebaseDetails.json"

const firebaseConfig = {
  apiKey: strings.apiKey,
  authDomain: strings.authDomain,
  databaseURL: strings.authDomain,
  projectId: strings.projectId,
  storageBucket: strings.storageBucket,
  messagingSenderId: strings.senderId,
  appId: strings.appId,
  measurementId: strings.measure,
};

export const requestPermission = async () => {
  if (window.location.protocol === strings.httpsLabel || window.location.hostname === strings.localhostLabel) {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: constants.vapidKey,
      });
      if (currentToken) {
        return currentToken;
      }
      return currentToken;
    } catch (err) {
      return null;
    }
  }
  else {
    return null
  }
};

export const getFirebaseToken = async (setTokenFound) => {
  try {
    const currentToken = await getToken(messaging, { vapidKey: constants.vapidKey });
    if (currentToken) {
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
  } catch (err) {
    return null;
  }
}

export const app = initializeApp(firebaseConfig);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

let messaging = null;
if (window.location.protocol === strings.httpsLabel || window.location.hostname === strings.localhostLabel) {
  messaging = getMessaging(app);
}
export { messaging };